import { render, staticRenderFns } from "./ServiceFilters.vue?vue&type=template&id=52e378e2&scoped=true&"
import script from "./ServiceFilters.vue?vue&type=script&lang=js&"
export * from "./ServiceFilters.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFilters.vue?vue&type=style&index=0&id=52e378e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e378e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e378e2')) {
      api.createRecord('52e378e2', component.options)
    } else {
      api.reload('52e378e2', component.options)
    }
    module.hot.accept("./ServiceFilters.vue?vue&type=template&id=52e378e2&scoped=true&", function () {
      api.rerender('52e378e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/ServiceFilters/ServiceFilters.vue"
export default component.exports